import { Link } from 'react-router-dom';
import { topics, siteMeta } from '@/mocks/site';

const Footer = () => (
  <footer className="mt-16 bg-secondary-900 text-background-50">
    <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-base font-bold text-background-50">
              瓜
            </span>
            <span className="font-brand text-xl">{siteMeta.name}</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
            {siteMeta.intro}
          </p>
          <p className="mt-5 flex items-center gap-2 text-sm text-background-100">
            <i className="ri-mail-line text-base"></i>
            {siteMeta.email}
          </p>
          <div className="mt-5 flex items-center gap-3">
            {['ri-wechat-line', 'ri-weibo-line', 'ri-radar-line', 'ri-rss-line'].map((icon) => (
              <span
                key={icon}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="社交媒体"
              >
                <i className={`${icon} text-lg`}></i>
              </span>
            ))}
          </div>
        </div>

        <nav aria-label="主题分类导航">
          <h3 className="font-heading text-sm font-bold text-background-50">主题分类</h3>
          <ul className="mt-4 space-y-2.5">
            {topics.map((topic) => (
              <li key={topic.slug}>
                <Link
                  to={`/topic/${topic.slug}`}
                  className="text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  {topic.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="站点导航">
          <h3 className="font-heading text-sm font-bold text-background-50">站点导航</h3>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link to="/" className="text-sm text-background-200 transition-colors hover:text-background-50">
                首页
              </Link>
            </li>
            <li>
              <Link to="/topics" className="text-sm text-background-200 transition-colors hover:text-background-50">
                爆料库
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-sm text-background-200 transition-colors hover:text-background-50">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/#subscribe" className="text-sm text-background-200 transition-colors hover:text-background-50">
                订阅爆料
              </Link>
            </li>
            <li>
              <Link to="/about#contact" className="text-sm text-background-200 transition-colors hover:text-background-50">
                联系我们
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      <div className="mt-10 flex flex-col gap-4 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} {siteMeta.name} · 保留所有权利</p>
        <p className="max-w-xl leading-relaxed">
          本站内容均为虚构娱乐内容，文中人物以匿名化方式表述，不代表对任何真实个人的评价。
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;